// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"52368d8b","294":"2988cee2"}[chunkId] + ".chunk.css";
};